import { render, staticRenderFns } from "./mb-data-owner-select.vue?vue&type=template&id=96f33a4c&scoped=true&"
import script from "./mb-data-owner-select.vue?vue&type=script&lang=ts&"
export * from "./mb-data-owner-select.vue?vue&type=script&lang=ts&"
import style0 from "./mb-data-owner-select.vue?vue&type=style&index=0&id=96f33a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f33a4c",
  null
  
)

export default component.exports